/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Web_Search_Search_SuccessInputs */

const es_tools_web_search_search_success = /** @type {(inputs: Tools_Web_Search_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda web completada`)
};

const en_tools_web_search_search_success = /** @type {(inputs: Tools_Web_Search_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web search complete`)
};

/**
* | output |
* | --- |
* | "Web search complete" |
*
* @param {Tools_Web_Search_Search_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_web_search_search_success = /** @type {((inputs?: Tools_Web_Search_Search_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Web_Search_Search_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_web_search_search_success(inputs)
	return en_tools_web_search_search_success(inputs)
});
export { tools_web_search_search_success as "tools.web_search.search_success" }